// extracted by mini-css-extract-plugin
module.exports = {"ButtonTree":"ReviewTree_ButtonTree__Bp2Xs","Title":"ReviewTree_Title__1sM5X","BtnSubInfo":"ReviewTree_BtnSubInfo__20bbR","OtherSiteBtn":"ReviewTree_OtherSiteBtn__3GffY"};